import React, { useEffect, useState } from "react";
import {
  Alert,
  Button,
  Col,
  Form,
  FormInput,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Row,
} from "shards-react";
import { doPost } from "../../backend/common";
import { getExcelSchema, saveExcelSchema } from "../../backend/files";
import {
  getAvgFemaleDataNewPrice,
  getAvgMaleDataNewPrice,
  verifyNewPriceData,
} from "../../services/excel-data";
import scheme from "../../utils/scheme.json";
import LuckysheetNewHistoric from "../LuckysheetNewHistoric";
import WeeklyDatePicker from "../common/WeeklyDatePicker";
import { FormBinefarPrediction } from "./FormBinefarPrediction";

const moment = require("moment");

function errorband(error) {
  if (error === undefined) {
    return null;
  }
  let theme = "danger";
  let message = error;
  if (error === false) {
    theme = "success";
    message = `Registrado nuevo historico`;
  }
  if (error === "updated") {
    theme = "warning";
    message = `Actualizado un historico anterior`;
  }
  return (
    <Alert className={"mt-2"} theme={theme}>
      {message}
    </Alert>
  );
}

const FormNewHistoric = ({ refresh, lastPrediction, animalType }) => {
  const luckysheet = window.luckysheet;
  const [result, setResult] = useState(new Map());

  // Forms
  const [numberOfChannels, setNumberOfChannels] = useState(new Map());
  const [averageWeight, setAverageWeight] = useState(new Map());
  const [date, setDate] = useState(moment().startOf("isoWeek"));

  const handleSubmit = async (event) => {
    event.preventDefault();
    const params = {
      time: date.format("DD-MM-YYYY"),
    };
    // Get male luckysheet data
    const rawMaleData = luckysheet?.getRangeArray("twoDimensional", {
      range: "A6:S9",
    });
    const maleDataPrice = getAvgMaleDataNewPrice(rawMaleData).filter(
      (data) => data.type === "price"
    );
    const maleDataVariation = getAvgMaleDataNewPrice(rawMaleData).filter(
      (data) => data.type === "variation"
    );
    // Get female luckysheet data
    const rawFemaleData = luckysheet?.getRangeArray("twoDimensional", {
      range: "A1:Q4",
    });
    // Verify data
    const err = verifyNewPriceData(rawMaleData, rawFemaleData);
    if (err) {
      const newResult = new Map(result);
      newResult.set("price", err);
      setResult(newResult);
      return;
    }

    const femaleData = getAvgFemaleDataNewPrice(rawFemaleData);
    const femaleDataPrice = femaleData.filter((data) => data.type === "price");
    const femaleDataVariation = femaleData.filter(
      (data) => data.type === "variation"
    );
    // Send data
    try {
      let body = [...maleDataPrice, ...femaleDataPrice];
      if (body.length > 0) {
        await doPost("/data/binefarBovinePrice", params, body, (res) => {
          const newResult = new Map(result);
          if (res.error) {
            newResult.set("price", res.error);
          } else {
            newResult.set("price", res.updated ? "updated" : false);
            refresh();
          }
          setResult(newResult);
        });
      }
      body = [...maleDataVariation, ...femaleDataVariation];
      if (body.length > 0) {
        doPost("/data/binefarBovineVariation", params, body, (res) => {
          const newResult = new Map(result);
          if (res.error) {
            newResult.set("price", res.error);
          } else {
            newResult.set("price", res.updated ? "updated" : false);
            refresh();
          }
          setResult(newResult);
        });
      }
      modifyScheme();
    } catch (e) {
      const newResult = new Map(result);
      newResult.set("price", "Error al enviar los datos");
      setResult(newResult);
    }
    setTimeout(() => {
      setResult(new Map());
    }, 5000);
  };

  const handleSubmit2 = async (event) => {
    event.preventDefault();
    const params = {
      time: date.format("DD-MM-YYYY"),
    };

    let body = [];
    averageWeight.forEach((value, key) => {
      body.push({
        numberOfChannels: numberOfChannels.get(key),
        avgWeight: value,
        type: key,
      });
    });

    try {
      await doPost("/data/binefarAvg", params, body, (data) => {
        const newResult = new Map(result);
        if (data.error) {
          newResult.set("avg", data.error);
        } else {
          newResult.set("avg", data.updated ? "updated" : false);
          refresh();
        }
        setResult(newResult);
      });
    } catch (e) {
      const newResult = new Map(result);
      newResult.set("avg", "Error al enviar los datos");
      setResult(newResult);
    }
    setTimeout(() => {
      setResult(new Map());
    }, 5000);
  };

  const loadScheme = () => {
    const params = {
      limit: 1,
      type: "NL",
    };
    luckysheet.create(scheme);
    getExcelSchema(params, (res) => {
      luckysheet.create({
        ...JSON.parse(res[0].data),
        hook: {
          cellUpdateBefore: (r, c, value) => {
            // If number format [0-9]*. then update the cell like 0.0[number]
            if (value?.match(/^[0-9]+$/)) {
              luckysheet.setCellValue(r, c, `0.0${value}`);
              return false;
            }
            // If number format -[0-9]*. then update the cell like -0.0[number]
            if (value?.match(/^-?[0-9]+$/)) {
              luckysheet.setCellValue(r, c, `-0.0${value * -1}`);
              return false;
            }
          },
        },
      });
    });
  };

  const modifyScheme = () => {
    const currentSchemeJson = JSON.stringify(luckysheet.toJson());
    const body = {
      data: currentSchemeJson,
      type: "NL",
    };
    saveExcelSchema(body, (res) => {
      if (res.error) {
        const newResult = new Map(result);
        newResult.set("price", res.error);
        setResult(newResult);
        return;
      }
    });
  };

  useEffect(() => {
    if (window.innerWidth < 768) {
      return;
    }
    loadScheme();
  }, [luckysheet]);

  return (
    <>
      <>
        <Row>
          <Col md="6" lg="3">
            <InputGroup className="mb-2">
              <WeeklyDatePicker date={date} changeDate={setDate} />
              <InputGroupAddon type="append">
                <InputGroupText>
                  <i className="material-icons">&#xE916;</i>
                </InputGroupText>
              </InputGroupAddon>
            </InputGroup>
          </Col>
        </Row>
        {window.innerWidth > 768 && (
          <>
            <LuckysheetNewHistoric />
            {errorband(result?.get("price"))}
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "space-between",
              }}
            >
              <Button className="mt-2" type="submit" onClick={handleSubmit}>
                Enviar - Semana {date.format("W")}
              </Button>
            </div>
          </>
        )}
      </>
      <Row>
        {window.innerWidth > 768 && (
          <Col>
            <Form
              className="mt-4"
              onSubmit={(event) => handleSubmit2(event)}
              style={{ maxWidth: 500, minWidth: 200 }}
            >
              <label>Machos</label>
              <Row>
                <Col className="mb-2">
                  <InputGroup>
                    <InputGroupAddon type="prepend">
                      <InputGroupText> %</InputGroupText>
                    </InputGroupAddon>
                    <FormInput
                      type="number"
                      step="any"
                      placeholder="Nº canales"
                      required
                      onChange={(event) => {
                        let newNumberOfChannels = new Map(numberOfChannels);
                        // Update numberOfChannels
                        newNumberOfChannels.set("male", event.target.value);
                        setNumberOfChannels(newNumberOfChannels);
                      }}
                    />
                  </InputGroup>
                </Col>
                <Col className="mb-2">
                  <InputGroup>
                    <InputGroupAddon type="prepend">
                      <InputGroupText> Kg </InputGroupText>
                    </InputGroupAddon>
                    <FormInput
                      type="number"
                      step="any"
                      placeholder="Peso medio"
                      required
                      onChange={(event) => {
                        let newAverageWeight = new Map(averageWeight);
                        // Update averageWeight
                        newAverageWeight.set("male", event.target.value);
                        setAverageWeight(newAverageWeight);
                      }}
                    />
                  </InputGroup>
                </Col>
              </Row>
              <label>Hembras</label>
              <Row>
                <Col className="mb-2">
                  <InputGroup>
                    <InputGroupAddon type="prepend">
                      <InputGroupText> %</InputGroupText>
                    </InputGroupAddon>
                    <FormInput
                      type="number"
                      step="any"
                      placeholder="Nº canales"
                      required
                      onChange={(event) => {
                        let newNumberOfChannels = new Map(numberOfChannels);
                        // Update numberOfChannels
                        newNumberOfChannels.set("female", event.target.value);
                        setNumberOfChannels(newNumberOfChannels);
                      }}
                    />
                  </InputGroup>
                </Col>
                <Col className="mb-2">
                  <InputGroup>
                    <InputGroupAddon type="prepend">
                      <InputGroupText> Kg </InputGroupText>
                    </InputGroupAddon>
                    <FormInput
                      type="number"
                      step="any"
                      placeholder="Peso medio"
                      required
                      onChange={(event) => {
                        let newAverageWeight = new Map(averageWeight);
                        // Update averageWeight
                        newAverageWeight.set("female", event.target.value);
                        setAverageWeight(newAverageWeight);
                      }}
                    />
                  </InputGroup>
                </Col>
              </Row>
              <Button type="submit" className="mb-2">
                Enviar - Semana {date.format("W")}
              </Button>
              {errorband(result?.get("avg"))}
            </Form>
          </Col>
        )}
        <Col md="6" lg="3">
          <FormBinefarPrediction
            date={date.format("YYYY-MM-DD")}
            refresh={refresh}
          />
        </Col>
      </Row>
      <hr className="my-2" style={{ width: "75%" }} />
    </>
  );
};

export default FormNewHistoric;
